import { render, staticRenderFns } from "./certfile.vue?vue&type=template&id=07abd8a9&scoped=true"
import script from "./certfile.vue?vue&type=script&lang=js"
export * from "./certfile.vue?vue&type=script&lang=js"
import style0 from "./certfile.vue?vue&type=style&index=0&id=07abd8a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abd8a9",
  null
  
)

export default component.exports